import React from 'react';

import './style.css';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import { useNavigate } from 'react-router';

export const Button = ({
  title,
  className,
  onClick,
  whitebtn,
  isSubmitBtn = false,
  isDisabled = false,
}) => {
  const navigate = useNavigate();
  return (
    <>
      {!whitebtn ? (
        <button
          className={`${className} ${
            isDisabled ? 'opacity-40 select-none pointer-events-none' : ''
          } btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6`}
          onClick={onClick}
          type={isSubmitBtn ? 'submit' : 'button'}
          disabled={isDisabled}
        >
          <span className="flex justify-center items-center">
            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
            <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
          </span>
          {title}
        </button>
      ) : (
        <button
          className={`${className} ${
            isDisabled ? 'opacity-40 select-none pointer-events-none' : ''
          } btnWhite font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6`}
          onClick={onClick}
          disabled={isDisabled}
        >
          <span className="flex justify-center items-center">
            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrowWhite" />
            <BsArrowRightShort className="h-[30px] w-[30px] tailArrowWhite" />
          </span>
          {title}
        </button>
      )}
    </>
  );
};
